// extracted by mini-css-extract-plugin
module.exports = {"container":"video-card_container__GvIMP","iframe":"video-card_iframe__2fkm6"};